/* eslint-disable jsx-a11y/control-has-associated-label */
/* eslint-disable jsx-a11y/no-autofocus */

import React from 'react';
import pt from 'prop-types';
import { Form, Field } from 'components/form';
import View from 'components/view';
import Modal from 'components/modal';
import UserPhoto from 'components/user/photo';
import KebabButton from 'components/button/kebab';
import { formatDate } from 'utils';
import './settings.scss';

export default class Users extends React.PureComponent {
  static propTypes = {
    users: pt.object,
    router: pt.object,
    onInviteUser: pt.func,
    onResendInvitation: pt.func,
    onTransferOwnership: pt.func,
    onRemoveUser: pt.func,
  };

  static contextTypes = {
    partner: pt.object.isRequired,
    user: pt.object.isRequired,
    isOwner: pt.bool.isRequired,
  };

  constructor(props) {
    super(props);

    this.state = {
      showInviteModal: false,
    };
  }

  onClickUser = (event) => {
    event.preventDefault();

    const userId = event.currentTarget.dataset.id;

    if (userId) {
      this.props.router.push(`/users/${userId}`);
    }
  };

  onClickInviteUser = (event) => {
    event.preventDefault();

    this.setState({
      showInviteModal: !this.state.showInviteModal,
    });
  };

  onSubmitInviteForm = async (values) => {
    const { onInviteUser } = this.props;
    const result = await onInviteUser(values);

    if (result) {
      this.setState({ showInviteModal: false });
    }
  };

  onClickResendInvitation = (event) => {
    event.preventDefault();
    event.stopPropagation();

    const { onResendInvitation } = this.props;
    const userId = event.currentTarget.dataset.id;

    if (userId) {
      onResendInvitation(userId);
    }
  };

  onClickTransferOwnership = (event) => {
    event.preventDefault();
    event.stopPropagation();

    const { onTransferOwnership } = this.props;
    const userId = event.currentTarget.dataset.id;

    if (userId) {
      onTransferOwnership(userId);
    }
  };

  onClickRemoveUser = (event) => {
    event.preventDefault();
    event.stopPropagation();

    const { onRemoveUser } = this.props;
    const userId = event.currentTarget.dataset.id;

    if (userId) {
      onRemoveUser(userId);
    }
  };

  renderInviteModal() {
    return (
      <Form onSubmit={this.onSubmitInviteForm} autoFocus={true}>
        <Modal
          title="Invite user"
          width={700}
          actions={[{ label: 'Send invitation', type: 'submit' }]}
          onClose={this.onClickInviteUser}
        >
          <fieldset>
            <Field
              type="text"
              name="email"
              label="Email address"
              rules="required, email"
              autoComplete="off"
            />
            <Field
              type="checkbox"
              name="notify_updates"
              label="Receive updates by email"
              defaultChecked={true}
            />
          </fieldset>
        </Modal>
      </Form>
    );
  }

  renderUserActionItems(user) {
    const { user: userSelf, partner, isOwner } = this.context;
    const actions = [];
    const isSelf = userSelf.id === user.id;
    const isOwnerUser = partner.owner_id === user.id;
    const canResendInvitation = !user.date_last_login;
    // Any member can remove any user; only the account owner is protected
    const canRemove = !isOwnerUser && !isSelf;
    const canTransferOwnership = isOwner && !isSelf && !canResendInvitation;

    if (canResendInvitation) {
      actions.push(
        <button data-id={user.id} onClick={this.onClickResendInvitation}>
          Resend invitation
        </button>,
      );
    }

    if (canTransferOwnership) {
      actions.push(
        <button data-id={user.id} onClick={this.onClickTransferOwnership}>
          Transfer ownership
        </button>,
      );
    }

    if (canRemove) {
      actions.push(
        <button
          className="danger"
          data-id={user.id}
          onClick={this.onClickRemoveUser}
        >
          Remove user
        </button>,
      );
    }

    return actions;
  }

  renderUserActions(user) {
    const actionItems = this.renderUserActionItems(user);
    const hasActionItems = actionItems.length > 0;

    if (!hasActionItems) {
      return null;
    }

    return (
      <KebabButton
        side="left"
        anchor="left"
        items={actionItems}
        button={false}
        alignOffset={25}
        onClick={(event) => event.stopPropagation()}
      />
    );
  }

  render() {
    const { partner } = this.context;
    const { users } = this.props;
    const { showInviteModal } = this.state;

    return (
      <div className="settings settings-users">
        <View
          headerTitle="Users"
          headerActions={[
            { label: 'Invite user', onClick: this.onClickInviteUser },
          ]}
        >
          <table className="collection-table collection-table-hoverable outer">
            <thead>
              <tr>
                <th className="image">User</th>
                <th />
                <th>Email</th>
                <th>Role</th>
                <th>Last login</th>
                <th />
              </tr>
            </thead>
            <tbody>
              {users.results.map((user) => (
                <tr key={user.id} onClick={this.onClickUser} data-id={user.id}>
                  <td className="image">
                    <span className="collection-table-images">
                      <UserPhoto user={user} width={45} height={45} />
                    </span>
                  </td>
                  <td className="settings-users-wrap">
                    {user.name ? (
                      user.name
                    ) : (
                      <span className="muted">&mdash;</span>
                    )}
                  </td>
                  <td className="settings-users-wrap">{user.email}</td>
                  <td>
                    {partner.owner_id === user.id ? 'Account owner' : 'Member'}
                  </td>
                  <td>
                    {user.date_last_login ? (
                      formatDate(user.date_last_login, 'age')
                    ) : (
                      <span className="muted">Email invite sent</span>
                    )}
                  </td>
                  <td className="settings-users-actions">
                    {this.renderUserActions(user)}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </View>
        {showInviteModal && this.renderInviteModal()}
      </div>
    );
  }
}
